// --------------------------------------------------------------
// Created On: 2026-04-13
// Author: Dimitra Weinstein
//
// Last Modified: 2026-04-13
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";
import Card from "../../components/Card/Card";
import TextBlurb from "../../components/TextBlurb/TextBlurb";
import styles from "./ErrorCannotCreateSubsidiariesPage.module.scss";

// Page for displaying an error to the user about them being unable to create subsidiaries.
export default function ErrorCannotCreateSubsidiariesPage(): Component {
  return (
    <div className={`${styles.body} p-4`} data-test="cannot-create-subsidiaries-error-card">
      <Card title="Cannot Create Subsidiaries">
        <div className="my-5">
          <TextBlurb
            title="Action Not Allowed"
            paragraph={"Cannot exceed the subsidiary hierarchy limit of 4 levels."}
            icon="exclamation-triangle"
          />
        </div>
      </Card>
    </div>
  );
}
